export const finalRecommendations = [
  {
    label: "Outstanding",
    value: 100000000,
  },
  {
    label: "Excellent",
    value: 100000001,
  },
  {
    label: "Very Good",
    value: 100000002,
  },
  {
    label: "Good",
    value: 100000003,
  },
  {
    label: "Weak",
    value: 100000004,
  },
];

export const refereeStatus = {
  empty: 0,
  potential: 100000000,
  sentFirstMail: 100000001,
  declinedEvaluating: 100000002,
  enoughReviews: 100000003,
  sentFirstMailReminder: 100000004,
  evaluationEmailReminder: 100000005,
  firstEmailSpecialReminder: 100000007,
  agreeToEvaluate: 100000011,
  evaluationReceivedFromReferee: 100000012,
};

export const advisorGradeStatus = {
  RequestForRefereeRecommendationFirstMail: 100000000,
  NotInMyField: 100000001,
  ConflictOfInterests: 100000002,
  TooBusy: 100000003,
  SentRefereeRecommendation: 100000004,
  RequestForFinalRanking: 100000005,
  SendFinalRecommendationThankYou: 100000006,
  SendRefereeRecommendationReminderMail: 100000007,
  WaitingForFirstMail: 100000008,
  RequestForFinalRankingReminder: 100000008,
};

export const boardDessicion = {
  Approved: 100000000,
  Dissapproved: 100000001,
};

export const recommendedBy = {
  Advisor: 100000000,
  GIFsInformationSpecialists: 100000001,
  Referee: 100000002,
  ApplicantSuggestedReviewer: 100000004,
  Other: 100000005,
  ApplicantReviewerNotToBeSent: 100000006,
};

export const ApplicantType = {
  CI: 0,
  PI: 1,
};
